import { useEffect, useState } from 'react';
import TwoFactorAuthModal from './TwoFactorAuthModal';
import TwoFactorAuthQrCodeModal from './TwoFactorAuthQrCodeModal';
import TwoFactorAuthActivateModal from './TwoFactorAuthActivateModal';
import TwoFactorAuthCompletedModal from './TwoFactorAuthCompletedModal';
import RecoveryCodesInfoModal from './RecoveryCodesInfoModal';
import RecoveryCodesGenerateModal from './RecoveryCodesGenerateModal';

const TwoFactorAuthWizard = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setStep('intro');
    }
  }, []);

  return (
    <>
      <TwoFactorAuthModal
        onRequestClose={onClose}
        isOpen={step === 'intro'}
        onBtnClick={() => setStep('qr')}
      />
      <TwoFactorAuthQrCodeModal
        onRequestClose={onClose}
        isOpen={step === 'qr'}
        onBtnClick={() => setStep('activate')}
      />
      <TwoFactorAuthActivateModal
        onRequestClose={onClose}
        isOpen={step === 'activate'}
        onBtnClick={() => setStep('complete')}
        onSecondaryBtnClick={() => setStep('qr')}
      />
      <TwoFactorAuthCompletedModal
        isOpen={step === 'complete'}
        onBtnClick={() => setStep('recovery-info')}
      />
      <RecoveryCodesInfoModal
        inAuthWizard={true}
        isOpen={step === 'recovery-info'}
        onBtnClick={() => setStep('recovery-generate')}
      />
      <RecoveryCodesGenerateModal
        isOpen={step === 'recovery-generate'}
        onBtnClick={() => setStep(null)}
        onRequestClose={() => setStep(null)}
      />
    </>
  );
};

export default TwoFactorAuthWizard;
